import base from "./base";
import { LOGIN_ENDPOINT } from "../config";

const login = async (username, password) => {
  const response = await base.api.post(`${LOGIN_ENDPOINT}/validate/`, {
    username,
    password,
  });
  return response;
};

export default {
  login,
};
